<template>
	<div class="flex w-full flex-col gap-2">
		<button
			v-for="stage in stages"
			:key="stage.status"
			type="button"
			tabindex="-1"
			role="menuitem"
			class="flex w-full items-center gap-1 rounded-lg bg-white px-3 py-2 text-left ring-1 ring-inset ring-grey-200 transition-colors hover:bg-grey-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-grey-950"
			:data-test="`move-to-stage-${stage.status}`"
			@click.stop="select(stage)"
		>
			<span class="flex min-w-0 flex-1 flex-col items-start gap-1">
				<span class="text-sm font-medium text-grey-800">
					{{ $t(stage.label) }}
				</span>
				<span class="text-xs text-grey-600">
					{{ $t(stage.hint) }}
				</span>
			</span>
		</button>
	</div>
</template>

<script>
const STAGES = [
	{ status: 'pending', label: 'general.requested' },
	{ status: 'accepted', label: 'general.accepted' },
	{
		status: 'interview',
		label: 'general.interview',
		hint: 'application.move-stage.interview-hint'
	},
	{ status: 'hired', label: 'general.hired' }
]

export default {
	name: 'MoveToStageOptions',
	props: {
		status: { type: String, required: true }
	},
	computed: {
		currentStatus() {
			return this.status === 'requested' ? 'pending' : this.status
		},
		stages() {
			return STAGES.filter(
				stage => stage.status !== this.currentStatus
			).map(stage => ({
				...stage,
				hint: stage.hint || 'application.move-stage.no-action'
			}))
		}
	},
	methods: {
		select(stage) {
			this.$emit('select', stage.status)
		}
	}
}
</script>
